import { ProcessVisitorResponse } from '../../../types'
import {
    API_DEACTIVATE_ACCOUNT,
    API_PROCESS_VISITOR,
    API_REQUIRED_CHANGE_REASON,
    API_REQUIRED_CHANGES_SUBMIT,
} from '../../constants/endpoints'
import { controller } from '../../utilities/abortController'
import { EdgeApiResponse, fetchStatusResolver } from './utilities'

export function getAffiliateQueries(object?) {
    // per Andrew, pass all query params
    // to process visitor as of 2/3/26
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    const visitorQueries = new URLSearchParams({
        ...Object.fromEntries(params),
        client_id: `1101`,
        get_user_data: '1',
    })

    if (object) {
        return Object.fromEntries(visitorQueries) as any
    }

    return visitorQueries.toString()
}

export async function fetchEntryInformation() {
    const affiliateQueries = getAffiliateQueries()
    const url = `${API_PROCESS_VISITOR}?${affiliateQueries}`
    const response = await fetch(url, {
        credentials: 'include',
        signal: controller.signal,
    })
    return (await response.json()) as EdgeApiResponse<ProcessVisitorResponse>
}

type DeactivateAccountResult = null

export async function deactivateAccount(token: string, password: string) {
    const response = await fetch(API_DEACTIVATE_ACCOUNT, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
        signal: controller.signal,
    }).then(fetchStatusResolver)
    const { err, errmsg } =
        (await response.json()) as EdgeApiResponse<DeactivateAccountResult>
    if (err !== 0) {
        throw new Error(`[deactivateAccount] failed, ${err}, ${errmsg}`)
    }
}

interface RequiredChangeReasonsResponse extends EdgeApiResponse {
    result: Record<number, string>
}

export async function getRequiredChangeReasons() {
    const response = await fetch(`${API_REQUIRED_CHANGE_REASON}`, {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
    })
    const resp: RequiredChangeReasonsResponse = await response.json()
    if (!resp || typeof resp !== 'object' || resp.err || resp.errmsg) {
        throw new Error(`[getRequiredChangeReasons] GET Error: ${resp.errmsg}`)
    }
    return resp
}

export interface ChangeDetailsErrors {
    errmsg: {
        desired_username?: string
        desired_password?: string
        admin_override?: boolean
        errors?: {
            password?: Array<string>
            username?: Array<string>
        }
    }
}

export interface RequiredChangesSubmissionResponse {
    err?: number
    id: string
    method: string
    responseVer: number
    errmsg?: ChangeDetailsErrors
}

export async function submitUsernameChanges(options: {
    desired_username?: string
    desired_password?: string
}): Promise<RequiredChangesSubmissionResponse> {
    const params = new URLSearchParams(options)
    const response = await fetch(
        `${API_REQUIRED_CHANGES_SUBMIT}?${params.toString()}&`,
        {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            signal: controller.signal,
        },
    )
    const res = (await response.json()) as RequiredChangesSubmissionResponse
    return res
}
